export default __webpack_public_path__ + "cb502af20ea22c626fd1c5f08c64d7f6.png";